import React, { Component } from 'react';
import Select from 'react-select';
import PopUp from '../../../commonModules/interface/PopUp';
import { Grid, List, ListItem, ListSubheader } from '@material-ui/core';
import { InputSelect } from '../../../commonModules/interface/form-input-inline';
import { Alert, AlertTitle } from '@material-ui/lab';

class FormChangeUserRole extends Component {
    render() {
        const { user, roleNames, roleList, ROLES} = this.props;
        let currentRole = ROLES[roleNames[user.role_name]]
        return (
            <PopUp 
                title="Modifier le role de cet utilisateur"
                block={true}
                close={this.props.handleClose}
                submitAction={this.props.handleSubmit}
                submitTitle="Modifier le role"
                maxWidth="md"
            >
                <Grid container spacing={2} >
                    <Grid item xs={12} sm={4} >
                    { user && 
                        <p>
                            {/* <i>Role Actuel: {user.role_name}</i> */}
                            <List className="list-group"
                                subheader={
                                    <ListSubheader component="div" id="nested-list-subheader">
                                        Role Actuel: {user.role_name}
                                    </ListSubheader>
                                }
                            >
                                { currentRole.accessPage.map( page => (
                                        <ListItem >{page.split("_")[1]}</ListItem>
                                        // <ListItem className="list-group-item">{page.split("_")[1]}</ListItem>
                                    ))
                                }
                            </List>
                        </p>
                    }
                    
                    </Grid>
                    <Grid item xs={12} sm={8}>
                        <InputSelect
                            options={roleList}
                            value={this.props.roleU}
                            label="Choisissez un Role"
                            onChange={ option => this.props.handleSelect(option, "roleU") }
                            error={this.props.errors.roleU}
                        />
                        
                        {this.props.roleU &&
                            <Alert severity="info">
                                <AlertTitle>Cet utilisateur aura accès aux Pages suivantes :</AlertTitle>
                            
                                <List className="list-group">
                                    { this.props.roleUDisplay.access.map( page => (
                                            <ListItem>{page}</ListItem>
                                        ))
                                    }
                                </List>
                            </Alert>
                        }                                            
                    
                    </Grid>
                </Grid>
            </PopUp>
        );
    }
}

export default FormChangeUserRole;